import { connect } from 'react-redux'
import * as selector from '../../state/auth/selector'
import PrivateRoute from './PrivateRoute'

const mapStateToProps = (state, props) => {
    return {
        user: selector.selectUser(state),
        hasRole: selector.selectHasRole(state, props.requiredRole),
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/PrivateRouteContainer.js